<template>
  <div>
  <el-form
    label-position="right"
    ref="form"
    :model="form"
    :rules="rules"
    style="width: 600px"
    label-width="150px"
  >
    <ProjectInfoFields
      ref="projectInfoFields"
      :form="form"
      :show-project-source="showProjectSource"
      :show-xt="false"
      :is-cqsw="isCqsw"
      :is-hlj="isHlj"
      :is-shgz="false"
      :is-bsgzw="isBsgzw"
      label-project-name="标段名称"
      label-project-code="项目编号"
      @source-change="onSourceChange"
      @self-fill-confirm="onSelfFillConfirm"
      @project-info-selected="onProjectInfoSelected"
    />
    <el-form-item label="项目地区" prop="rojectArea">
      <el-cascader
        v-model="form.rojectArea"
        :options="options"
        @change="cascaderHandleChange"
      ></el-cascader>
    </el-form-item>
    <el-form-item label="标段ID" prop="packageId" v-show="false">
      <el-input v-model="form.packageId" />
    </el-form-item>
    <el-form-item label="开标时间" prop="openingDate">
      <el-date-picker
        :picker-options="{
          disabledDate: disabledDate,
        }"
        type="datetime"
        v-model="form.openingDate"
        placeholder="请选择开标时间"
      />
      <div class="el-upload__tip">
        <!-- {{form.applicationChannelBankId}} -->
        {{
          state.web_type === 'paper' && (form.applicationChannelBankId === '1' || form.applicationChannelBankId === '7')
            ? '申请保函时间距离项目开标时间少于2个工作日，银行将无法保证开出投标保函！'
            : state.web_type === 'paper' &&
              form.applicationChannelBankId === '29'
            ? '申请保函时间距离项目开标时间少于1个工作日，银行将无法保证开出投标保函！'
            : isElectron
            ? ''
            : '申请保函时间距离项目开标时间少于2个工作日，银行将无法保证开出投标保函！'
        }}
      </div>
    </el-form-item>

    <el-form-item label="投标有效期（天）" prop="validityPeriod">
      <el-input v-model="form.validityPeriod" placeholder="请输入投标有效期" />
    </el-form-item>
    <el-form-item label="投标有效期到期日">
      <span style="color: #606266">{{ expirationDate }}</span>
    </el-form-item>
    <el-form-item label="招标人名称" prop="tenderCompanyName">
      <el-input
        v-model="form.tenderCompanyName"
        placeholder="请填写招标人全称"
      />
    </el-form-item>

    <el-form-item
      label="选择保函出具银行"
      prop="applicationChannelBankId"
      ref="applicationChannelBankId"
      v-if="isApplicationChannelBankId"
    >
      <el-radio-group v-model="form.applicationChannelBankId"  @change="handleSelect">
          <el-radio v-for="(item, index) in form.bankLetter" :key="index"  :label="item.id">{{item.bankName}}
          </el-radio>
      </el-radio-group>
      <div class="el-upload__tip" v-if="isTip">
        {{ issueTimeTipMsg }}
      </div>
    </el-form-item>
    <el-form-item label="招标人地址" :prop="isElectron?'':'tenderLinkAddress'">
      <el-input
        v-model="form.tenderLinkAddress"
        placeholder="请输入招标人地址"
      />
    </el-form-item>
    <el-form-item v-if="apiType === '0'" label="代理机构名称" prop="agentName">
          <el-input
            v-model="form.agentName"
            placeholder="请输入代理机构名称"
          />
        </el-form-item>
    <el-form-item label="上传招标文件" prop="tenderFileId" ref="tenderFileId">
      <FileUpload uploadTitle="上传招标文件" :id.sync="form.tenderFileId" :maxSize="fileMaxSize"
       accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
       :filetypes = "['pdf','doc','docx','rar','zip','jpg','bmp','gif','png','jpeg']"

      >
        <div>
          <!-- <li>补遗、澄清等相关文件，请与招标文件一起打包上传</li> -->
          <li>支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</li>
          <!-- <span>2、支持PDF、RAR、WORD、ZIP文档</span> -->
        </div>
      </FileUpload>
    </el-form-item>
    <el-form-item v-if="isPaper" label="纸质保函邮寄地址" prop="postAddress">
      <el-input
        v-model="form.postAddress"
        placeholder="请填写纸质保函邮寄地址"
      ></el-input>
    </el-form-item>
    <el-form-item label="投标保证金（万元）" prop="guaranteeAmount">
      <el-input-number
        v-model="form.guaranteeAmount"
        @change="handleCalcAmount"
        :min="0.0001"
        :max="80"
        :step="10"
        label="请输入投标保证金（万元）"
        name="guaranteeAmount"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="保函费用" prop="productAmount">
      <div class="text-red fw-6 fs-md" v-loading="loadingAmount">
        {{ (form.productAmount?form.productAmount:0)+specialFormatAmount }}
      </div>
    </el-form-item>
    <!-- <el-form-item v-if="!isPaper" label="是否加急" prop="urgent">
      <el-checkbox v-model="form.urgent" @change="calcAmount"></el-checkbox>
    </el-form-item> -->
          <el-form-item v-if="!isAhGzElectronicBank && isBasic" label="保函格式" prop="remarks">
        <el-switch
  v-model="form.basic"
   active-text="按招标文件中的特殊格式"
  inactive-text="正常格式"
  active-value="1"
  inactive-value="0"
 >
</el-switch>
 </el-form-item>
    <el-form-item label="备注" prop="remarks">
      <el-input v-model="form.remarks" />
    </el-form-item>
     <el-form-item v-if="invoiceTipMsg" label="开票须知" prop="invoiceTip">
      <el-checkbox size="mini"  v-model="form.invoiceTip">
        {{
          invoiceTipMsg
        }}
</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-button @click="onPrev"> 上一步 </el-button>
      <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
      <el-button type="primary" @click="onSubmit" class="elBtn">
        提交
      </el-button>
    </el-form-item>
  </el-form>
  </div>
</template>

<script>
import FileUpload from './components/fileUpload'
import ProjectInfoFields from '@/components/guaranteeStepView/projectInfoFields.vue'
import { mapGetters, CONFIG_GETTERS } from '@/store/modules/config'
import { APPLY,mapMutations } from '../../../store/modules/applybank'

import { cloneDeep, debounce } from 'lodash'
import {
  queryBankByProvince,
  calculateInsurance,
  submitBank,
  queryApiConfigInfo
} from '@/api/comm'

import { renderArea } from '@/shared/location'
import { data } from '@/util/cityData'
import { isLogin, showLogin } from '@/shared/user'
import dayjs from 'dayjs'

import { submitElectronicBank } from '@/views/electronic/api/api'
import store from './mixins/store'
import { queryOrderByOuterOrderNo,queryOrderDetail } from '@/api/order'
import { GetApiCodeById } from '@/shared/type'
import { t } from 'vxe-table'
import { ORDER_TYPE, saveCurrentDraft, clearCurrentDraft } from '@/shared/guaranteeDraft'
export default {
  name: 'Step2',
  components: {
    FileUpload: FileUpload,
    ProjectInfoFields: ProjectInfoFields,
  },
  mixins: [store],
  watch: {
    'form.tenderFileId': function (newVal, oldVal) {
      if (newVal) {
        this.$refs.tenderFileId.clearValidate()
      }
    },
    'form.applicationChannelBankId': function (newVal, oldVal) {
      //华商银行调整上传文件大小限制
      this.fileMaxSize = newVal === '29'?(1024*1024*12):1073741824
      //山西农商行不允许特殊格式出函
      this.isBasic = newVal === '21'?false:true
      this.form.basic = newVal === '21'?'0': this.form.basic
    },
    'form.basic': function (newVal, oldVal) {
      this.specialFormatAmount = newVal === '1'?100: 0
    }


  },
  data() {
    let FileIdpass = (rule, value, callback) => {
      if (this.form.tenderFileId) {
        callback()
      } else {
        return callback(new Error('请填写必填项目'))
      }
    }
    const validityPeriod = (rule, value, callback) => {
      if (
        /^\d+$/.test(this.form.validityPeriod) &&
        this.form.validityPeriod > 0 &&
        this.form.validityPeriod <= 120
      ) {
        callback()
      } else {
        callback(new Error('请填写大于0小于120的正整数'))
      }
    }
    const validatorProductAmount = (rule, value, cb) => {
      if (!this.form.productAmount) {
        return cb(new Error('获取金额失败请联系客服'))
      }
      cb()
    }
    const validatorGuaranteeAmount = (rule, value, cb) => {
      if (!this.form.guaranteeAmount) {
        return cb(new Error('请填写保证金额'))
      }
      if (/\.\d{5,}$/.test('' + this.form.guaranteeAmount)) {
        return cb(new Error('金额只保留小数点后4位'))
      }
      cb()
    }
    const validatorOpeningDate = (rule, value, cb) => {
      if (!this.form.openingDate) {
        return cb(
          new Error(
            '请选择开标时间，若开标时间变更，请在招标文件处上传变更文件'
          )
        )
      }
      // if (dayjs().add(12, 'hours').isAfter(dayjs(this.form.openingDate))) {
      //   return cb(
      //     new Error(
      //       `申请保函时间距离项目开标时间少于12个小时，银行将无法保证开出投标保函！`
      //     )
      //   )
      // }
      cb()
    }
    return {
      options: data,
      isApplicationChannelBankId: true,
      isTip: true,
      apiCode: '',
      loadingAmount: false,
      bankLoading: false,
      form: {
        basic: '0',
        bankLetter: [],
        applicationChannelBankId: null
      },
      rules: {
        projectSource: [
          { required: true, message: '请选择项目来源', trigger: 'change' },
        ],
        invoiceTip:[
          { required: true,
          validator: (_, v, cb) => {
            if (this.form.invoiceTip) {
              cb()
            } else {
              cb(new Error('请勾选同意开票须知'))
            }
          }, trigger: 'change' },
        ],
        applicationChannelBankId: {
          required: true,
          validator: (_, v, cb) => {
            if (this.form.applicationChannelBankId) {
              cb()
            } else {
              cb(new Error('请选择保函出具银行'))
            }
          },
        },
        projectName: [
          { required: true, message: '请填写标段名称', trigger: 'change' },
        ],
        projectCode: [
          { required: true, message: '请填写标段编号', trigger: 'change' },
        ],
        validityPeriod: [
          {
            required: true,
            trigger: 'change',
            validator: validityPeriod,
          },
        ],
        tenderCompanyName: [
          { required: true, message: '请填写招标人全称', trigger: 'change' },
        ],
        postAddress: {
          required: true,
          message: '请填写纸质保函邮寄地址',
          trigger: 'change',
        },
        openingDate: [
          {
            required: true,
            validator: validatorOpeningDate,
            trigger: 'change',
          },
        ],
        tenderFileId: [
          { required: true, message: '请上传招标文件', validator: FileIdpass },
        ],
        tenderLinkAddress: {
          required: true,
          message: '请填写招标人地址',
        },
        agentName: {
          required: true,
          message: '请填写代理机构名称',
          trigger: 'change',
        },
        rojectArea: [
          {
            required: true,
            validator(r, v, callback) {
              if (v) {
                callback()
              } else {
                callback(new Error('请选择项目地区'))
              }
            },
          },
        ],
        productAmount: [
          {
            required: true,
            validator: validatorProductAmount,
          },
        ],
        guaranteeAmount: [
          {
            required: true,
            validator: validatorGuaranteeAmount,
          },
        ],
      },
      specialFormat : false,
      specialFormatAmount : 0,
      fileMaxSize: 1073741824,
      invoiceTipMsg: '',
      issueTimeTipMsg:'',
      apiType: '',
      isBasic: true,
      draftSaving: false,
    }
  },
  async beforeMount() {
    console.log(this.state)
    this.form = cloneDeep({...this.state, bankLetter: [], applicationChannelBankId: null} || {})
    this.specialFormatAmount = this.form.basic === "1"?100:0
    const { orderId } = this.$route.query
    if (orderId) {
      this.form.orderId = orderId
    }
    if (this.$store.state.letter.isCqsw) {
      this.form.projectSource = '2'
    }
    const { outerOrderNo, orderID } = this.$route.query
    if (outerOrderNo) {
      await this.loadOrderData('outer', outerOrderNo)
    } else if (orderID) {
      await this.loadOrderData('id', orderID)
    }
    this.initViewData()
    this.queryApiConfigInfo()
  },
  computed: {
    showProjectSource() {
      return !this.$route.query.outerOrderNo && !this.isAhGzElectronicBank && !this.isCqsw && !this.isHlj && !this.isBsgzw
    },

    expirationDate() {
      const { openingDate, validityPeriod } = this.form
      if (!openingDate || !validityPeriod) {
        return ''
      }
      return dayjs(openingDate)
        .add(validityPeriod || 0, 'd')
        .format('YYYY-MM-DD HH:mm:ss')
    },

    isAhGzElectronicBank() {
      return this.$route.path.includes('anhui') || this.$route.path.includes('guizhouBank')
    },

    isPaper() {
      return this.form.web_type === 'paper'
    },
    isElectron() {
      return this.form.web_type === 'electron'
    },
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    },
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    },
  },
  methods: {
    ...mapMutations({
      performance: APPLY.GUARANTEE,
      clear: APPLY.CLEAR,
    }),
    async loadOrderData(type, value) {
      try {
        let res
        if (type === 'outer') {
          res = await queryOrderByOuterOrderNo(value)
          this.apiCode = res.data?.apiCode || ''
        } else {
          res = await queryOrderDetail(value)
          this.apiCode = res.data?.apiCode || ''
        }
        if (res.data) this.apiCode = res.data.apiCode
        // this.form.rojectArea = renderArea(this.form)
        // const { province, city, district } = this.form
        // if (province && city && district) {
        //   this.queryBankByProvinceCb({ province, district, city })
        // }
      } catch (err) {
        console.error('加载订单数据失败：', err)
        this.$message.error('订单数据加载失败，请刷新重试')
      }
    },
    initViewData() {
      if (this.form.openingDate) {
        this.form.openingDate = dayjs(this.form.openingDate).toDate()
      }
      this.form.rojectArea = renderArea(this.form)
      const { province, district, city } = this.form
      if (province && district && city) {
        this.queryBankByProvinceCb({ province, district, city })
      }
      if (this.form.urgent) {
        // '0' => false
        this.form.urgent = !!+this.form.urgent
      }
      if (this.form.guaranteeAmount) {
        this.form.guaranteeAmount = Number(this.form.guaranteeAmount)
        this.calcAmount()
      }

    },
    queryBankByProvinceCb(citys) {
      const { province, district, city } = citys
      if (!province || !city || !district) {
        this.form.bankLetter = []
        this.isApplicationChannelBankId = false
        this.$message.warning('地区参数不完整，无法查询银行')
        return
      }
      if (this.bankLoading) return
      this.bankLoading = true

      const apiId = this.getApiId()
      queryBankByProvince({
        apiId: apiId,
        province,
        district,
        city,
        bankLevel: 1,
        isExectronic: this.isElectron ? '1' : '0',
        applicationChannelBankId: this.form.applicationChannelBankId,
      }).then((res) => {
        this.form.bankLetter = cloneDeep(res.data || [])
        if (this.form.bankLetter.length === 0) {
          this.isApplicationChannelBankId = false
          this.$message.warning('当前地区暂无可用的保函出具银行')
          this.form.applicationChannelBankId = null
        } else {
           this.isApplicationChannelBankId = true
           const savedBankId = this.form.applicationChannelBankId
           const bankExists = this.form.bankLetter.some(bank => bank.id === savedBankId)
           if (!bankExists) {
             this.form.applicationChannelBankId = this.form.bankLetter[0].id
           }
           const currentBank = this.form.bankLetter.find(bank => bank.id === this.form.applicationChannelBankId)
           this.form.bankName = currentBank?.bankName || ''
           this.issueTimeTipMsg = currentBank?.issueTimeDescription || ''
           this.invoiceTipMsg = currentBank?.attr1 || ''
        }
        this.calcAmount()
      }).catch((err) => {
        console.error('查询银行失败：', err)
        this.form.bankLetter = []
        this.isApplicationChannelBankId = false
        this.$message.error('银行列表加载失败，请稍后重试')
      }).finally(() => {
        this.bankLoading = false
      })
    },
    onAreaChange: debounce(function() {
      this.form.applicationChannelBankId = null
      this.isTip = true
      this.isApplicationChannelBankId = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate('applicationChannelBankId')
      })
      const { province, district, city } = this.form
      this.queryBankByProvinceCb({ province, district, city })
      this.calcAmount()
    }, 300),
    cascaderHandleChange(e) {
      const [province, city, district] = [e[0], e[1], e[2]]
      Object.assign(this.form, {
        province: province,
        district: district,
        city: city,
      })
      this.onAreaChange()
    },
    onSourceChange() {
      this.calcAmount()
    },
    onSelfFillConfirm() {
      this.calcAmount()
    },
    // 选择保函出具银行
    handleSelect(e) {
      this.form.applicationChannelBankId = e
      const bankInfo = this.form.bankLetter.find((i) => i.id === e)
      this.form.bankName = bankInfo?.bankName || ''
      this.invoiceTipMsg = bankInfo?.attr1 || ''
      this.issueTimeTipMsg = bankInfo?.issueTimeDescription || ''
      this.isTip = true
      this.calcAmount()
    },
    disabledDate(cur) {
      return dayjs().isAfter(dayjs(cur).add(12, 'h'))
    },
    onSubmit() {
      // 银行保函都是线上  电子担保保函 选择基本户线下 否则线上   履约保函都是线下 没有支付动作 （安徽移动出函机构，重庆水务走华商银行走线下）
      if (!isLogin()) {
        showLogin()
        return false
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.guarantee(this.form)
          const viewData = cloneDeep(this.form)
          viewData.orderType = '8000'
          if (!this.$route.query.orderID) {
            viewData.orderId = null
          }
          viewData.urgent = viewData.urgent ? 1 : 0
          viewData.endDate = this.expirationDate

          const loading = this.$loading({
            lock: true,
            text: 'Loading',
          })

          const cb = (res) => {
            this.clear()
            loading.close()
            if (res.code === 200) {
              // 提交成功，清空 Redis 草稿
              clearCurrentDraft(this, ORDER_TYPE.BANK_8000)
              this.$router.push({
                // path: viewData.web_type === 'electron'?'/electronic_bank_pdf_view':'/bank_pdf_view',
                path: '/bank_pdf_view',
                query: {
                  orderId: res.data.orderId,
                  pdfId: res.data.electronicPdfFileId,
                  commitmentPdfId: res.data.commitmentPdfId,
                  web_type: viewData.web_type,
                  bank_id: viewData.applicationChannelBankId,
                  backType: this.$route.path,
                  outerOrderNo: this.$route.query.outerOrderNo,
                },
              })
            }
          }
          // 电子银行保函提交
          if (this.isElectron) {
          submitElectronicBank(viewData)
                .then(cb)
                .catch((e) => {
                  loading.close()
                })
          } else {
            // 纸质银行保函提交
            submitBank(viewData)
              .then(cb)
              .catch((e) => {
                loading.close()
              })
          }
        }
      })
    },
    calcAmount() {
      if (!this.form.guaranteeAmount) return
      this.loadingAmount = true
      const apiId = this.getApiId()
      calculateInsurance({
        productType: '8000',
        guaranteeAmount: Number((this.form.guaranteeAmount * 10000).toFixed(0)),
        apiId: apiId,
        province: this.form.province,
        urgent: this.form.urgent ? 1 : 0,
        applicationChannelBankId: this.form.applicationChannelBankId,
        outerOrderNo: this.$route.query.outerOrderNo,
        orderId: this.$route.query.orderID,
        projectSource: this.form.projectSource,
        sourceRadio: this.form.sourceRadio
      }).then((res) => {
        console.log(res)
        this.loadingAmount = false
        this.form.productAmount = res.data.productPrice + res.data.servicePrice
      }).catch(() => {
        this.loadingAmount = false
        this.$message.error('保函费用计算失败，请稍后重试')
      })
    },
    handleCalcAmount: debounce(function () {
      this.calcAmount()
    }, 200),
    onPrev() {
      this.guarantee(this.form)
      // 构造干净的 query：清 step1Id、打 step2Id 标记 —— 不直接修改 this.$route.query
      const { step1Id: _s1, step2Id: _s2Old, ...restQ } = this.$route.query
      const newQ = { ...restQ, step2Id: 'step2' }
      const pFast = this.$route.path.split('/bank')[0]
      this.$router.push({
        path: `${pFast || '/anhui' || 'guizhouBank'}/bank/step1`,
        query: newQ,
      })
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.BANK_8000, 'step2', this.form)
      } finally {
        this.draftSaving = false
      }
    },
    onProjectInfoSelected() {
      this.calcAmount()
    },
    getApiId(){
      if(this.state.apiAccessConfigId && !this.state.apiId){
        this.state.apiId = GetApiCodeById(this.state.apiAccessConfigId)
       }
      return this.$route.path.includes('anhui')? 'ahyd':this.$route.path.includes('guizhouBank')?
          'gzyh': this.apiCode ? this.apiCode : this.state.apiId
    },
    queryApiConfigInfo(){
      const apiId = this.getApiId()
      if (apiId) {
        queryApiConfigInfo({apiId}).then((res) => {
          this.apiType = res.data? res.data.apiType:'0'
        }).catch(() => {
          this.apiType = '0'
        })
      } else {
        this.apiType = '0'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.self-fill-btn {
  margin-left: 12px;
  color: #409eff;
  font-size: 14px;
  &:hover {
    color: #66b1ff;
  }
}
</style>